<ion-tabs (ionTabsDidChange)="onTabChange($event)">
  <ion-tab-bar slot="bottom">
    <ion-tab-button tab="home">
      <ion-icon src="../../assets/icon/logo.svg"></ion-icon>
    </ion-tab-button>
    <ion-tab-button tab="prizes">
      <ion-icon name="trophy"></ion-icon>
    </ion-tab-button>
    <ion-tab-button *ngIf="showTransportation" tab="places">
      <ion-icon name="bus"></ion-icon>
    </ion-tab-button>
    <ion-tab-button tab="booking">
      <ion-icon name="bag-handle"></ion-icon>
      <ion-badge *ngIf="bookingBadgeCount>0" color="danger">{{bookingBadgeCount}}</ion-badge>
    </ion-tab-button>
    <ion-tab-button class="tab-with-badge" tab="notifications" >
      <ion-icon name="notifications"></ion-icon>
      @if (notificationsBadgeCount > 0) {
        <div class="tab-badge">{{notificationsBadgeCount}}</div>
      }
      
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
